module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.fails.js
 ** module id = 845
 ** module chunks = 0
 **/